// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"_1tdrZ6nw","followerCounterRangeSelectors":"_359VN7nu"};